import $ from 'jquery';
import skHeader from './components/header/sk-header';
import snowplow from './components/sk-snowplow';
import footer from './components/sk-footer';
import vm from './vue/sk-main-vue';
import countryCode from './twig/analytics/country-code';
import marketoSetup from './components/sk-marketo-setup';
import cookies from './twig/helpers/cookies';
import dataLayerEvents from './analytics/sk-data-layer-events';
import dataLayerEventsSupport from './analytics/sk-data-layer-events-support';
import sticky from './twig/helpers/sticky-kit';
import smoothScroll from './lib/sk-smooth-scroll';
import skHelpers from './components/sk-helpers';
import skUI from './components/sk-ui';
import skLegacy from './components/sk-legacy';
import skReferer from './analytics/sk-referer';
import skGoogleAnalytics from './analytics/sk-ga-events';
import wasThisHelpful from './support/was-this-helpful';

$(() => {
  cookies.init();
  skHelpers.youtubeModal();
  skLegacy.handlers();
  skGoogleAnalytics.all();
  skReferer.init();
  snowplow.load();
  skUI.init();
  marketoSetup.init();
  vm.init();
  if (window.sk_is_support) {
    dataLayerEventsSupport.init();
    wasThisHelpful.init();
  } else {
    dataLayerEvents.init();
  }
  skHeader.init();
  countryCode.init(); // needs to happen after vm.init for promos
  footer.init();
  sticky.init();
  smoothScroll();
});
